export function LoadingState() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-100 px-4">
      <div className="w-full max-w-md animate-pulse rounded-2xl bg-white p-6 shadow-[0_18px_50px_rgba(0,0,0,0.12)]">
        <div className="h-14 rounded-xl bg-neutral-200" />
        <div className="mt-6 h-8 rounded-lg bg-neutral-200" />
        <div className="mt-6 space-y-4">
          <div className="h-24 rounded-xl bg-neutral-100" />
          <div className="h-24 rounded-xl bg-neutral-100" />
          <div className="h-24 rounded-xl bg-neutral-100" />
        </div>
        <div className="mt-6 h-14 rounded-xl bg-neutral-200" />
      </div>
    </div>
  );
}
